export default {
  BusinessLabelHandData: {
    header: {
      labelName: 'Label name',
      labelType: 'Label type',
      status: 'Label status',
    },

    table: {
      labelName: 'Label name',
      labelType: 'Label type',
      changeFlag: 'Removable',
      preview: 'Tab preview'
    },
    msgWarning: 'You have selected the label that is being activated and cannot be deleted'
  },
  BusinessLabelHandPage: {
    title: 'Account Information',
    labelName: 'Label name',
    labelType: 'Label type',
    labelStyle: 'Label style',
    textContent: 'Text content',
    textContentText: 'Please control the text within 6 characters',
    textColor: 'Choose the color',
    preview: 'Tab preview',
    editLabel: 'Edit label',
    addLabel: 'Add label',
  },
};
